<template>
  <div id="ANSWERS">
    <Header />
    <!-- 컨텐츠 -->
    <div id="container" class="contents">
      <BreadCrumb />
      <div id="contents">
        <div class="sub_header bg14">
          <h3 class="title">커뮤니케이션 플랫폼</h3>
          <p class="txt">
            고객과의 모든 디지털 접점을 한 곳에서!<br />SK 텔링크가 제공하는
            스마트 커뮤니케이션 플랫폼으로 고객 경험을 혁신하세요.
          </p>
          <img
            src="/content/images/sub_header_biz14-m.png"
            alt="비쥬얼 이미지"
          />
        </div>
        <!-- biz -->
        <div class="biz tab_area">
          <div class="tab_type01_communication">
            <ul>
              <li>
                <router-link to="/view/business/people">PEOPLE</router-link>
              </li>
              <li>
                <router-link to="/view/business/moments">MOMENTS</router-link>
              </li>
              <li>
                <router-link to="/view/business/conversations"
                  >CONVERSATIONS</router-link
                >
              </li>
              <li class="on" title="현재메뉴 선택됨">
                <router-link to="/view/business/answers">ANSWERS</router-link>
              </li>
            </ul>
          </div>
          <div class="main-wrap">
            <div class="main-title">
              <div class="main-title-box">
                <div class="main-top-title">WHY SK텔링크 CPaaS?</div>
                <div class="main-top-text">
                  메시지, 상담, 챗봇까지 한 번에, 한 곳에서!<br />기업 고객이
                  원하는 효율성과 편리함을 모두 담았습니다.
                </div>
              </div>
            </div>
            <div class="divider"></div>
            <div class="btn_center2">
              <div class="btn double">
                <a href="tel:1670-0315" class="btn_cs2 mobile-only"
                  ><span>고객상담 번호 : 1670-0315</span></a
                >
                <span class="btn_cs pc-only">고객상담 번호 : 1670-0315</span>
                <a href="mailto:cpaas@sk.com" class="btn_cs2 mobile-only"
                  ><span>고객상담 이메일 : cpaas@sk.com</span></a
                >
                <span class="btn_cs2 pc-only"
                  >고객상담 이메일 : cpaas@sk.com</span
                >
              </div>
              <ul>
                <li>
                  <a
                    href="/content/download/250811-SKTL_CPaas_브로슈어.pdf"
                    onclick=""
                    class="btn_ico ico2 mb-30"
                    download
                    ><span>상품 브로슈어 다운로드</span></a
                  >
                </li>
              </ul>
            </div>
            <div class="main_grid">
              <div class="grid-box">
                <div class="grid-img">
                  <div class="circle">
                    <img src="/content/images/people_handshake.png" alt="" />
                  </div>
                </div>

                <div class="grid-title">PEOPLE</div>
                <div class="grid-text">
                  고객 데이터 관리 및 맞춤 커뮤니케이션
                </div>
              </div>
              <div class="grid-box">
                <div class="grid-img">
                  <div class="circle">
                    <img src="/content/images/people_letter.png" alt="" />
                  </div>
                </div>
                <div class="grid-title">MOMENTS</div>
                <div class="grid-text">
                  자동화된 타이밍별 메시지/이벤트 전송
                </div>
              </div>

              <div class="grid-box">
                <div class="grid-img">
                  <div class="circle">
                    <img src="/content/images/people_headset.png" alt="" />
                  </div>
                </div>
                <div class="grid-title">CONVERSATIONS</div>
                <div class="grid-text">옴니채널 통합 실시간 상담</div>
              </div>

              <div class="grid-box">
                <div class="grid-img">
                  <div class="circle">
                    <img src="/content/images/people_24.png" alt="" />
                  </div>
                </div>
                <div class="grid-title" :class="{ active: isCurrentPage }">
                  ANSWERS
                </div>
                <div class="grid-text" :class="{ active: isCurrentPage }">
                  AI 챗봇 기반 24시간 자동 응대
                </div>
              </div>
            </div>
            <div class="main-bottom_box">
              <div class="main-bottom-title">ANSWERS 서비스란?</div>
              <div class="main-bottom-text">
                AI와 자연어처리를 활용한 24시간 무중단 고객 문의 응대 및 업무
                자동화 플랫폼<br />
                반복 질문 자동 응답과 상담사 연계 기능으로 상담 효율 극대화
              </div>
            </div>
          </div>
          <!-- tab_cont PEOPLE-->
          <div class="tab_cont">
            <div class="on tab1">
              <div class="advice_list gray">
                <h4>이런 기업들이 사용하면 좋아요!</h4>
                <p>
                  <span class="hashtag"># 자동응답</span
                  ><span class="hashtag"># 24시간 상담</span
                  ><span class="hashtag"># AI챗봇</span>
                </p>
                <div class="advice_scroll">
                  <div>
                    <ul class="list-scroll-small">
                      <li>
                        <div>
                          <img src="/content/images/biz_ans_1.png" alt="" />
                        </div>
                        <p>반복적인 고객 문의가 많은<br />이커머스, 쇼핑몰</p>
                      </li>
                      <li>
                        <div class="img_2">
                          <img src="/content/images/biz_ans_2.png" alt="" />
                        </div>
                        <p>
                          비대면 상담 자동화를 원하는<br />공공기관, 교육기관
                        </p>
                      </li>
                      <li>
                        <div>
                          <img src="/content/images/biz_ans_3.png" alt="" />
                        </div>
                        <p>야간 및 휴일 상담<br />강화가 필요한 기업</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="advice_list white">
                <h4>특징을 확인해보세요</h4>
                <div class="advice_scroll">
                  <div>
                    <ul class="list-scroll-small">
                      <li>
                        <div>
                          <img src="/content/images/biz_ans_4.png" alt="" />
                        </div>
                        <dl>
                          <dt>고도화된 AI 대화</dt>
                          <dd>AI 자연어처리 기반<br />정확한 응답 제공</dd>
                        </dl>
                      </li>
                      <li>
                        <div class="img_5">
                          <img src="/content/images/biz_ans_5.png" alt="" />
                        </div>
                        <dl>
                          <dt>24/7 무중단 고객 응대</dt>
                          <dd>
                            24시간 무중단 대응 시스템으로<br />고객 편의성 향상
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <div>
                          <img src="/content/images/biz_ans_6.png" alt="" />
                        </div>
                        <dl>
                          <dt>손쉬운 챗봇 구축 및 운영</dt>
                          <dd>
                            관리자용 챗봇 시나리오<br class="w_hide" />
                            손쉬운 관리 툴 제공
                          </dd>
                        </dl>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="advice_list">
                <h4>기업의 기대효과는 무엇일까요?</h4>
                <div class="advice_scroll">
                  <div>
                    <ul class="list-scroll-small">
                      <li>
                        <dl>
                          <dt class="txt_point01">운영 비용 절감</dt>
                          <dd>
                            반복 문의 자동처리로 상담사<br />업무 집중도 향상 및
                            인건비 절감
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt class="txt_point01">고객 만족도 향상</dt>
                          <dd>
                            24시간 빠르고 정확한 응대로<br />대기시간과 이탈
                            감소
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt class="txt_point01">업무 효율성 극대화</dt>
                          <dd>
                            챗봇과 상담사의 원활한 연계로<br />복잡한 상담은
                            신속하게 이관
                          </dd>
                        </dl>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- //biz -->
        </div>
      </div>
    </div>
    <!--// 컨텐츠 -->
    <Footer />
    <SummitControl />
  </div>
</template>

<script>
import Header from "@/components/Header";
import BreadCrumb from "@/components/BreadCrumb";
import Footer from "@/components/Footer";
import SummitControl from "@/components/SummitControl";

export default {
  name: "CommunicationPlatform",
  metaInfo: {
    title: "CommunicationPlatform | 커뮤니케이션 플랫폼 | 사업소개",
  },
  components: {
    Header,
    BreadCrumb,
    Footer,
    SummitControl,
  },
  props: {},
  emits: [],
  data() {
    return {};
  },
  computed: {
    isCurrentPage() {
      return this.$route.path.includes("/answers");
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.biz.tab_area {
  padding: 0;
  background: #fff;
}
.img_2 {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    height: 60%;
    width: 60%;
  }
}
.img_5 {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    height: 80%;
    width: 80%;
  }
}
.btn_ico {
  margin-top: 30px;
}
.sub_header h3,
.sub_header p {
  color: #222222;
}
.sub_header {
  height: 373px;
  padding: 134px 0 135px;
  text-align: center;
}
.divider {
  width: 100%;
  max-width: 1120px;
  height: 0;
  border-top: 1px dotted #c6c6c6;
  margin-bottom: 40px;
}
.main-wrap {
  background: #ffffff;
  padding: 100px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.main-title {
  font-size: 40px;
  text-align: center;
  font-weight: 400;
  color: #333333;
  margin-top: 40px;
  line-height: 1.5;
}

.main_grid {
  display: flex;
  flex-direction: row;
  /* max-width: 1120px; */
  background-color: #f9f9f9;
  margin: 28px auto;
  width: 100%;
  /* margin-bottom: 70px; */
  justify-content: center;
  position: relative;
  z-index: 2;
}

.grid-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 40px;
  text-align: center;
  position: relative;
}

.grid-img {
  position: relative;
  img {
    position: absolute;
    width: 60%;

    object-fit: cover;
  }
}

.grid-title {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 15px;
  color: #444444;
  line-height: 1;
}

.grid-text {
  font-size: 15px;
  font-weight: 300;
  line-height: 1.5;
  color: #666666;
}
.grid-title.active,
.grid-text.active {
  color: #ff630a;
}
.grid-title.active {
  font-weight: 600;
}
.grid-text.active {
  font-weight: 400;
}
.circle {
  width: 250px;
  height: 250px;
  border-radius: 50%;
  background-color: #ffffff;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-bottom {
  text-align: center;
  max-width: 1120px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  padding: 88px 0;
  gap: 122px;
}
.main-bottom_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 35px;
  text-align: center;
  margin-top: 100px;
}
.main-title-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 26px;
}
.main-top-title {
  font-size: 44px;
  font-weight: 400;
  margin-bottom: 20px;
  color: #333333;
}
.main-bottom-title {
  font-size: 44px;
  font-weight: 400;
  color: #333333;
}

.main-top-text,
.main-bottom-text {
  font-size: 20px;
  font-weight: 400;
  line-height: 1.6;
  color: #666666;
}
.main-top-text {
  margin-bottom: 74px;
}

@media (max-width: 1023px) {
  .main-wrap {
    padding: 40px 0;
  }
  .biz.tab_area {
    padding: 0 0 100px;
    background: #fff;
  }
  .sub_header {
    padding: 0;
    width: 100%;
    height: auto;
  }
  .divider {
    width: 90%;
    height: 0;
    border-top: 1px dotted #c6c6c6;
    margin-bottom: 40px;
  }
  .main_grid {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    width: 100%;
    margin-bottom: 40px;
    padding: 0 20px;
  }

  .grid-box {
    padding: 30px 20px;

    /* 모바일에서는 구분선 제거 */
    &::after,
    &::before {
      display: none;
    }
  }

  .circle {
    width: 100px;
    height: 100px;
  }

  .grid-title {
    font-size: 20px;
  }

  .grid-text {
    font-size: 14px;
  }
  .main-title {
    font-size: 28px;
    text-align: center;
    font-weight: 400;
    color: #333333;
    margin-top: 20px;
    line-height: 1.5;
  }
  .main-top-title,
  .main-bottom-title {
    font-size: 24px;
  }
  .main-top-text,
  .main-bottom-text {
    font-size: 16px;
  }
  .main-bottom_box {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    text-align: center;
  }
  .main-top-text {
    margin-bottom: 20px;
  }
  .btn_center2 .double {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    text-align: center;
  }

  .btn_center2 .double a {
    /* float: right; */
    margin-left: 0;
    text-align: center;
  }

  .btn_center2 .double a span {
    padding-left: 0;
    background: none;
  }
  /* 
  .btn_center .double a:first-child {
    float: left;
  } */
}
</style>
